import "./header.scss";
import UserMenu from "components/UserMenu/UserMenu";

// Шапка страниц входа/публичных страниц — без логотипа организации
export default function Header({ setMobileOpen, user }) {
  return (
    <>
      <header className="w-full">
        <UserMenu setMobileOpen={setMobileOpen} user={user} />
      </header>
    </>
  );
}
